<template>
  <div class="whole">
    <div class="search">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="valueYear" :placeholder="$t('placeholder.Year2')" clearable filterable @change="indexSearch(valueYear,1)">
            <el-option
                v-for="item in optionsYear"
                :key="item.value"
                :label="item.label"
                :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <!--   选择需要比较的城市1     -->
        <el-form-item>
          <el-cascader
              collapse-tags
              filterable
              :placeholder="$t('placeholder.City1')"
              :options="optionsCity"
              v-model="valueCity1"
              style="width: 180px"
              @change="indexSearch(valueCity1,2)"
          ></el-cascader>
        </el-form-item>

        <!--   选择需要比较的城市2     -->
        <el-form-item>
          <el-cascader
              collapse-tags
              filterable
              :placeholder="$t('placeholder.City2')"
              :options="optionsCity"
              v-model="valueCity2"
              style="width: 180px"
              @change="indexSearch(valueCity2,2)"
          ></el-cascader>
        </el-form-item>


        <!--   这是该年份下,两个城市共有的指标     -->
        <el-form-item>
          <el-select v-if="isOk" v-model="valueIndex" multiple collapse-tags filterable :placeholder="$t('placeholder.Index1')" style="width: 220px">
            <el-option
                v-for="item in optionsIndex"
                :key="item.id"
                :label="item.name_cn"
                :value="item.id">
            </el-option>
          </el-select>

          <el-select v-if="!isOk" v-model="valueIndex" multiple collapse-tags filterable :placeholder="$t('placeholder.Index1')" style="width: 220px">
            <el-option
                v-for="item in optionsIndex"
                :key="item.id"
                :label="item.name_en"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="compareSearch(valueCity1,valueCity2,valueIndex)">{{ $t("button.Search") }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="container">
      <div id="echart"></div>
    </div>

  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "compareDataSearch",
  data(){
    return{
      isOk:'',
      cityName1:'',
      cityName2:'',
      yValue:[],
      xCity1:[],
      xCity2:[],
      optionsCity: [],
      valueYear:'',
      valueIndex: [],
      optionsIndex:[],
      optionsYear: [],
      valueCity1:'',
      valueCity2:'',
    }
  },
  methods:{
    //获取城市数据---级联选择器
    getCity(){
      var that=this
      var continent={}
      var country={}
      var city={}
      request.get('/continent').then(async function (res){
        for(let i=0;i<res.data.length;i++){
          let continentItem=res.data[i]
          continent={
            label:'',
            value:'',
            children:[]
          }
          if(that.$i18n.locale==='cn'){
            continent.label=continentItem.name_cn
          }
          else{
            continent.label=continentItem.name_en
          }
          continent.value=continentItem.id

          //根据洲id获取国家，存在临时country字典中，并push到continent的children列表中
          await request.get('/country?continent_id='+continentItem.id).then(async function (res1){
            for(let j=0;j<res1.data.length;j++){
              let countryItem=res1.data[j]
              country={
                label:'',
                value:'',
                children:[]
              }
              if(that.$i18n.locale==='cn'){
                country.label=countryItem.name_cn
              }
              else{
                country.label=countryItem.name_en
              }
              country.value=countryItem.id
              //根据国家id获取城市，存在临时city字典中，并push到country的children列表中
              await request.get('city?country_id='+countryItem.id).then(function (res2){
                for(let k=0;k<res2.data.length;k++){
                  let cityItem=res2.data[k]
                  city={
                    label:'',
                    value:'',
                  }
                  if(that.$i18n.locale==='cn'){
                    city.label=cityItem.name_cn
                  }
                  else{
                    city.label=cityItem.name_en
                  }
                  city.value=cityItem.id
                  country.children.push(city)
                }
                continent.children.push(country)
              }).catch(function (err2){
                console.log(err2)
              })
            }
          }).catch(function (err1){
            console.log(err1)
          })
          that.optionsCity.push(continent)
        }
      }).catch(function (err){
        console.log(err)
      })
    },
    //获取指标数据
    indexSearch(value,n){
      this.valueIndex=""
      this.$forceUpdate();
      //情况1：根据城市获取指标
      if(n===2){
        request.get('/cidata?city_id='+value[2]).then(result => {
          var index=[]
          result.data.forEach(function (data){
            index.push(data.eva_index)
          })
          //两个城市拥有的指标与年份指标的交集
          this.optionsIndex=this.optionsIndex.filter(itemF=>index.some(ele=>ele.id===itemF.id))
          if(this.optionsIndex.length===0){
            if(this.$i18n.locale==='cn'){
              alert("该选择下没有数据！请您重新选择！")
            }
            else{
              alert("No data under this selection! Please select again!")
            }
            this.valueIndex=[]
            this.valueYear=''
            this.valueCity1=''
            this.valueCity2=''
            this.optionsIndex=[]
          }
        }).catch(err => {
          console.log(err)
        })
      }
      //情况2：根据年份获取指标
      if(n===1){
        this.optionsIndex=[]
        request.get("/EvaIndex?year="+value).then(result => {
          this.optionsIndex=result.data
        }).catch(err => {
          console.log(err)
        })
        //备选：查询多个年份
        //问题：若查询多个年份，无法处理 不同年份中相同的指标，且每年体系不同，就看一个年的即可。
        // for(let i=0;i<value.length;i++){
        //   request.get("/EvaIndex?year="+value[i]).then(result => {
        //     //所有年份下，指标的并集
        //     this.optionsIndex=Array.from(new Set([...this.optionsIndex, ...result.data]));
        //   }).catch(err => {
        //     console.log(err)
        //   })
        // }
      }
    },
    //获取选择框中选择的数据
    compareSearch(valueCity1,valueCity2,valueIndex){
      this.yValue=[]
      this.xCity1=[]
      this.xCity2=[]
      let that=this
      if(valueCity1[2]===valueCity2[2]){
        if(this.$i18n.locale==='cn'){
          alert("请选择两个不同的城市进行比较！")
        }
        else{
          alert("Please select two different cities for comparison！")
        }
      }else{
        for(let i=0;i<valueIndex.length;i++){
          request.get('/dataAnalysis/cityCompare?city1_id='+valueCity1[2]+'&city2_id='+valueCity2[2]+'&eva_indexsId='+valueIndex[i]).then(function (res){
            if(that.$i18n.locale==='cn'){
              if(i===0){
                that.cityName1=res.data[0].city.name_cn
                that.cityName2=res.data[1].city.name_cn
              }
              that.yValue.push(res.data[0].eva_index.name_cn)
            }
            else{
              if(i===0) {
                that.cityName1 = res.data[0].city.name_en
                that.cityName2 = res.data[1].city.name_en
              }
              that.yValue.push(res.data[0].eva_index.name_en)
            }
            that.xCity1.push(res.data[0].score)
            that.xCity2.push(res.data[1].score)
            that.getLoadEcharts();
          }).catch(function (err){
            console.log(err)
          })
        }
      }
    },
    //加载图表
    getLoadEcharts() {
      var myChart = this.$echarts.init(document.getElementById("echart"));
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: this.yValue
        },
        series: [
          {
            name: this.cityName1,
            type: 'bar',
            data: this.xCity1
          },
          {
            name: this.cityName2,
            type: 'bar',
            data: this.xCity2
          }
        ]
      };
      myChart.setOption(option);
    },
  },
  //在页面创建时，获取城市的列表+该用户拥有年份的权限
  mounted() {
    this.optionsYear= JSON.parse(window.sessionStorage.getItem('years'))
    this.getCity();
  },
  created() {
    if(this.$i18n.locale==='cn'){
      this.isOk=true
    }
    else{
      this.isOk=false
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
.container{
  height: 450px;
  width: 900px;
  margin: 30px;
}
#echart{
  width: 100%;
  height: 100%;
}
</style>